import { Body, Controller, Post } from "@nestjs/common";
import { VillageTransportService } from "./village-transport.service";
import { ApplicationExceptionHandler } from "@gtpl/shared-utils/error-messages";
import { VillageTransportDto } from "./dto/village-transport.dto";
import { CommonResponse } from "@gtpl/shared-models/production-management";

@Controller('village-transport-cost')
export class VillageTransportCostController{
    constructor(
        private readonly service:VillageTransportService,
        private readonly applicationExceptionHandler: ApplicationExceptionHandler // Assuming you have this service for handling exceptions

    ){}
    @Post('/saveVillageTransportInfo')
    async  saveVillageTransportInfo(@Body() data: { data : VillageTransportDto[],user: string}):Promise<CommonResponse>{
        try {
            return this.service.saveVillageTransportInfo(data);
        } catch (err) {
            return this.applicationExceptionHandler.returnException(CommonResponse, err);
        }
    }
    @Post('/getAllVillageTransporationCostData')
    async getAllVillageTransporationCostData():Promise<CommonResponse>{
        try{
            return await this.service.getAllVillageTransporationCostData();
        }
        catch (error){
            return this.applicationExceptionHandler.returnException(CommonResponse,error);
        }
    }
}
